// extracted by mini-css-extract-plugin
export default {"Form":"LoginView_Form__WhhlA","Logo":"LoginView_Logo__+LUh6"};